// @flow

import type {Reducer, Store} from 'redux'
import {combineReducers} from "redux"
import {routerReducer as router} from "react-router-redux"
import {readLocalStorage} from "../store/localStorage"
import userReducer from "./userReducer"
import applicationsReducer from "./applicationsReducer"
import userInfoReducer from "./userInfoReducer"
import registrationReducer from "./registrationReducer"
import resetPasswordReducer from "./resetPasswordReducer"

import {ACTION_LOCALE_CHANGE} from "../constants"
import type {Action, actionLocaleChange, Locale, State} from '../types'
import enterpriseAccountReducer from "./enterpriseAccountReducer"
import enterpriseAccountsReducer from "./enterpriseAccountsReducer"
import invitationsReducer from "./invitationsReducer"
import licenseReducer from "./licenseReducer"
import countriesReducer from "./countriesReducer"
import usersWithStatusReducer from "./cogoland/usersWithStatusReducer"
import scheduleReducer from "./cogoland/scheduleReducer"
import selectedCogolandSessionReducer from "./cogoland/selectedCogolandSessionReducer"

type ReducerMap = {[key:string]:Reducer<State, Action>}

const localeReducer = (state: Locale = readLocalStorage('locale', 'en'), {type, locale}:actionLocaleChange) => {

  if (type === ACTION_LOCALE_CHANGE) {
    return locale
  }

  return state
}





export const makeRootReducer = (asyncReducers: ReducerMap) => {
  return combineReducers({
    // Add sync reducers here
    user: userReducer,
    applications: applicationsReducer,
    selectedUser: userInfoReducer,
    locale: localeReducer,
    resetPassword: resetPasswordReducer,
    registration: registrationReducer,
    enterpriseAccounts: enterpriseAccountsReducer,

    countries: countriesReducer,
    license:licenseReducer,
    enterpriseAccount: enterpriseAccountReducer,
    invitations: invitationsReducer,

    usersWithStatus: usersWithStatusReducer,
    schedule: scheduleReducer,
    selectedCogolandSession: selectedCogolandSessionReducer,


    router,
    ...asyncReducers
  })
}

export const injectReducer = (store: Store<State, Action>, {key, reducer}:{key:string, reducer: Reducer<State, Action>}) => {
  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js